import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  @Input()
  title = '';

  @Input()
  confirmMessage = '';

  @Input()
  confirmActionText = '';

  @Input()
  allowMarkAsYellow = false;

  @Input()
  yellowCardText = 'Дати жовту картку';

  @Output()
  onConfirm: EventEmitter<string | true> = new EventEmitter<string | true>();

  @Output()
  onMarkAsYellow: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  isAdminCustomInput = false;

  inputText = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>) {}

  ngOnInit(): void {
  }

  confirm() {
    this.onConfirm.next(this.isAdminCustomInput ? this.inputText : true);
    this.dialogRef.close();
  }

  markAsYellow() {
    this.onMarkAsYellow.next();
    this.dialogRef.close();
  }
}
